import { render, staticRenderFns } from "./PetInsurance.vue?vue&type=template&id=2d046812&"
import script from "./PetInsurance.vue?vue&type=script&lang=js&"
export * from "./PetInsurance.vue?vue&type=script&lang=js&"
import style0 from "./PetInsurance.vue?vue&type=style&index=0&id=2d046812&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports